@file:OptIn(InternalResourceApi::class)

package albert.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/albert.composeapp.generated.resources/"

internal val Res.font.Geist: FontResource by lazy {
      FontResource("font:Geist", setOf(
        ResourceItem(setOf(), "${MD}font/Geist.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("Geist", Res.font.Geist)
}
